import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'heritagewatch_onboarded'

/**
 * Tracks whether the user has seen the first-visit onboarding flow.
 * Persisted in localStorage, keyed by STORAGE_KEY.
 */
export function useOnboarding() {
  const [isOnboarded, setIsOnboarded] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1'
    } catch {
      // Private-mode Safari, SSR, etc. — treat as first visit
      return false
    }
  })

  // Keep state in sync across tabs
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setIsOnboarded(e.newValue === '1')
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [])

  const dismissOnboarding = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      // Ignore storage failures — the session-only state below still hides the UI
    }
    setIsOnboarded(true)
  }, [])

  return { isOnboarded, dismissOnboarding }
}

export const ONBOARDING_STORAGE_KEY = STORAGE_KEY
